import { render, staticRenderFns } from "./EmployeeInvite.vue?vue&type=template&id=5227eec7&"
import script from "./EmployeeInvite.vue?vue&type=script&lang=js&"
export * from "./EmployeeInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports